export default {
    ytEmbedUrlView: 'https://www.youtube.com/embed/YOUTUBE_VIDEO_ID',
    ytEmbedUrl: 'https://www.youtube.com/embed/YOUTUBE_VIDEO_ID',
}